import { Link } from "react-router-dom";
import useReveal from "../../hooks/useReveal";

const courts = [
	{
		sport: "Padel",
		title: "A padel score tracker that knows the rules",
		copy: "Keep padel score on Apple Watch without losing the serving order, tie-break or deciding point. Choose the format, play the rally, and let Racketly keep up.",
		guide: "/blog/padel-scoring-rules-guide",
		guideLabel: "Read the padel scoring guide",
	},
	{
		sport: "Tennis",
		title: "A tennis scorekeeper for the match in front of you",
		copy: "Record every point from your wrist, then revisit your tennis match on iPhone. A calmer way to keep the score honest from first serve to final set.",
		guide: "/blog/how-to-use-racketly",
		guideLabel: "See how Racketly works",
	},
	{
		sport: "Pickleball",
		title: "Pickleball scoring, always within reach",
		copy: "Use the same Apple Watch score tracker across your racket sports, with a match history that stays together even when your week moves from padel to pickleball.",
		guide: "/blog",
		guideLabel: "Explore all guides",
	},
];

export default function CourtBenefitsSection() {
	const headRef = useReveal(0);

	return (
		<section id="apple-watch-score-tracker" className="py-20 md:py-28" style={{ background: "var(--color-paper)" }} aria-labelledby="court-benefits-heading">
			<div className="container mx-auto px-4 sm:px-6">
				<div ref={headRef} className="reveal max-w-3xl mb-12">
					<p className="font-display font-bold uppercase mb-3" style={{ fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)", color: "var(--color-accent)" }}>Made for match day</p>
					<h2 id="court-benefits-heading" className="font-display font-bold uppercase" style={{ fontSize: "var(--text-display-s)", lineHeight: "var(--lh-tight)", color: "var(--color-ink)" }}>One Apple Watch score tracker. Every kind of court.</h2>
					<p className="mt-4" style={{ fontSize: "var(--text-lg)", color: "var(--color-muted)", maxWidth: "var(--measure)" }}>Racketly is built around the scorekeeping moments that interrupt a great match — with the sport-specific context to make every tap count.</p>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-3 gap-5">
					{courts.map((court, index) => <CourtCard key={court.sport} court={court} index={index} />)}
				</div>
			</div>
		</section>
	);
}

function CourtCard({ court, index }) {
	const ref = useReveal(index + 1);
	return (
		<article ref={ref} className="reveal court-benefit-card p-7 flex flex-col" style={{ border: "var(--rule-fine) solid var(--color-ink)", background: "var(--color-paper-2)" }}>
			<p className="font-display font-bold uppercase mb-5" style={{ color: "var(--color-accent)", fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)" }}>{court.sport}</p>
			<h3 className="font-display font-bold uppercase" style={{ color: "var(--color-ink)", fontSize: "var(--text-2xl)", lineHeight: "var(--lh-snug)" }}>{court.title}</h3>
			<p className="mt-4" style={{ color: "var(--color-muted)", lineHeight: "var(--lh-body)" }}>{court.copy}</p>
			<Link className="mt-7 font-display font-bold uppercase inline-flex items-center gap-2" style={{ color: "var(--color-ink)", fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)" }} to={court.guide}>{court.guideLabel}<span aria-hidden="true" style={{ color: "var(--color-accent)" }}>→</span></Link>
		</article>
	);
}
